/** 외부·전용 페이지를 새 탭에서 엽니다 (챗봇 탭 유지). */
export function openAppUrlInNewTab(url: string): void {
  // noopener 사용 시 window.open()은 보안상 null을 반환하므로
  // 반환값으로 성공 여부를 판단하면 location.assign fallback이 잘못 실행됩니다.
  window.open(url, '_blank', 'noopener,noreferrer');
}
